module.exports = __webpack_public_path__ + "static/media/refuseShelter.ddcd5a3a.png";